<template>
  <div class="qyjs_box">

   <div>
	 <router-view></router-view>
   </div>
    <div class="box">
		<div>
			<div class="schmain">
				<div class="sch-ul" >
					<div class="sch-li" >
						<div class="schli-l"><img :src="UPLODE_URL+info.schoolLogos" alt="" /></div>
						<div class="schli-r">
							<div class="schli-rt">
								<span class="schli-rt-a">{{info.schoolName}}</span>
								<span class="schli-rt-b">{{info.schoolCityOne}}</span>
							
							</div>
							<div class="schli-rb">
								<span v-if="info.natureName">{{info.natureName}}</span>
								<span v-if="info.attribute">{{info.attribute}}</span>
								<span v-if="info.belong">{{info.belong}}</span>
								<span v-if="info.typeName">{{info.typeName}}</span>
								
								<!-- <span v-if="item.oneJihua!=0">{{item.oneJihua!=0?'101计划':''}}</span>
								<span v-if="item.zuoyueJihua==1">{{item.zuoyueJihua==1?'卓越工程师':''}}</span>
								<span v-if="item.youJihua==1">{{item.youJihua==1?'国优计划':''}}</span> -->
							</div>
						</div>
					</div>
					
					<div class="home_top_swiper">
						<div class="home_top_swiper_left">
							<el-carousel trigger="click" height="100%" :interval="3000" class="el-car">
								<el-carousel-item v-for="(item, index) in info.schoolImage" :key="index">
									<img :src="UPLODE_URL+item" alt="" class="img" />
								</el-carousel-item>
							</el-carousel>
						</div>
						<div class="home_top_swiper_right">
							<div class="introduction-rank-list">
								<!-- <div class="introduction-rank-list-box nnnew" v-if="college_data.zrRank">
									<text>{{college_data.zrRank}}</text>
									<text>全国排名</text>
								</div> -->
								<div class="introduction-rank-list-box nnnew" v-if="info.ruanke">
									<div class="nnna">{{info.ruanke}}</div>
									<div style="font-size: 12px;">软科综合</div>
								</div>
								<div class="introduction-rank-list-box nnnew" v-if="info.xiaoyouhui">
									<div class="nnna">{{info.xiaoyouhui}}</div>
									<div style="font-size: 12px;">校友会综合</div>
								</div>
								<div class="introduction-rank-list-box nnnew" v-if="info.wushulian">
									<div class="nnna">{{info.wushulian}}</div>
									<div style="font-size: 12px;">武书连</div>
								</div>
								<div class="introduction-rank-list-box nnnew" v-if="info.qs">
									<div class="nnna">{{info.qs}}</div>
									<div style="font-size: 12px;">QS</div>
								</div>
								<div class="introduction-rank-list-box nnnew" v-if="info.us">
									<div class="nnna">{{info.us}}</div>
									<div style="font-size: 12px;">US</div>
								</div>
								
							</div>
							
							
							
							<div class="rightul">	
								<div class="rightli goGws" @click="goGw(info.schoolSite)">官方网址：{{info.schoolSite}}</div>
								<div class="rightli">招生电话：{{info.recruitTel}}</div>
								<div class="rightli">电子邮箱：{{info.email}}</div>
								<div class="rightli">学校地址：{{info.address}}</div>
								<div class="rightli" v-if="info.schoolVr&&info.schoolVr!='--'">校园VR：{{info.schoolVr}}</div>
							</div>
							
						</div>
					</div>
					
					
				</div>
			</div>
		</div>
		
		
		
		
		<div class="boxA">
			<div class="box-tit"><span v-for="(item,index) in navData" :class="navDataIndex==index?'onsele':''" @click="navClick(index)">{{item}}</span></div>
			<!-- <div class="search-t">
				<el-input  placeholder="请输入院校名称" v-model="schoolName"  class="input-with-select" clearable>
					<el-button type="danger" slot="append" icon="el-icon-search" @click="schGet">搜索</el-button>
				</el-input>
			</div> -->
			<div class="jiben" v-if="navDataIndex==0">
				<div class="introduction-rank-list">
					<!-- <div class="introduction-rank-list-box nnnew" v-if="college_data.zrRank">
						<text>{{college_data.zrRank}}</text>
						<text>全国排名</text>
					</div> -->
					<div class="introduction-rank-list-box nnnew" v-if="info.createDate">
						<div>建校时间</div>
						<div class="nnna">{{info.createDate}}</div>
					</div>
					<div class="introduction-rank-list-box nnnew" v-if="info.numSubject">
						<div>国家重点科学</div>
						<div class="nnna">{{info.numSubject}}</div>
					</div>
					<div class="introduction-rank-list-box nnnew" v-if="info.oneCourseNum">
						<div>一流学科</div>
						<div class="nnna">{{info.oneCourseNum}}</div>
					</div>
					
					<div class="introduction-rank-list-box nnnew" v-if="info.keyLab">
						<div>重点实验室</div>
						<div class="nnna">{{info.keyLab}}</div>
					</div>
					<div class="introduction-rank-list-box nnnew" v-if="info.masterRate">
						<div>保研率</div>
						<div class="nnna">{{info.masterRate}}</div>
					</div>
					<div class="introduction-rank-list-box nnnew" v-if="info.doctorPoint">
						<div>博士点</div>
						<div class="nnna">{{info.doctorPoint}}</div>
					</div>
					<div class="introduction-rank-list-box nnnew" v-if="info.masterPoint">
						<div>硕士点</div>
						<div class="nnna">{{info.masterPoint}}</div>
					</div>
					<div class="introduction-rank-list-box nnnew" v-if="info.oneJihua">
						<div>101计划</div>
						<div class="nnna">{{info.oneJihua}}</div>
					</div>
					<div class="introduction-rank-list-box nnnew" v-if="info.zuoyueJihua">
						<div>卓越工程师</div>
						<div class="nnna">{{info.zuoyueJihua}}</div>
					</div>
					<div class="introduction-rank-list-box nnnew" v-if="info.youJihua">
						<div>国优计划</div>
						<div class="nnna">{{info.youJihua==1?'是':'否'}}</div>
					</div>
				</div>
				
				<div class="jianjie">
					<div class="jianjie-t">院校简介</div>
					<div class="jianjie-m" v-html="info.history"></div>
				</div>
				<div class="jianjie" >
					<div class="jianjie-t" v-if="chineseArray.length">
						<div>学科评估</div>
						<div v-if="chineseArray.length>5" @click="allA()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span :class="dexnNum==5?'el-icon-arrow-down':'el-icon-arrow-up'"></span></div>
					</div>
					<div class="jianjie-m" style="margin-bottom: 30px;" v-if="chineseArray.length">
						<div class="introduction-major-box-th" style="height: 100rpx;background: #F5FAFE;display: flex;width: 100%;height: 50px;line-height: 50px;">
							<div class="" style="flex: 1;height: 100%;padding: 0;text-align: center">
								<span style="padding-left: 30rpx;">学科名称</span>
							</div>
							<div class="" style="flex: 1;height: 100%;padding: 0;text-align: center">
								<span>等级</span>
							</div>
						</div>
						<div style="display: flex;width: 100%;border: 1px solid #f0f0f0;">
							<div class="introduction-major-box-list" style="flex: 1;" >
								<div class="introduction-major-box-list-item" v-for="(item,index) in chineseArray"
									:key="index" v-if="index<dexnNum">
									<div class="introduction-major-box-list-item-class" style="padding-left: 30rpx;text-align: center">
										<span>{{item}}</span>
									</div>
								</div>
							</div>
							<div class="introduction-major-box-list" style="flex:1;">
								<div class="introduction-major-box-list-item" v-for="(item,index) in gradeArray"
									:key="index" v-if="index<dexnNum">
									<div class="introduction-major-box-list-item-name">
										<div class="" style="text-align: center">
											<span>{{item}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!--  -->
						
					</div>
					
					
					<div v-if="info.zuoyueList" class="ub10">
						<div class="jianjie-t">
							<div>卓越工程师</div>
							<div v-if="info.zuoyueList.length>5" @click="allB()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span :class="dexnNumB==5?'el-icon-arrow-down':'el-icon-arrow-up'"></span></div>
							
							</div>
						<div >
							<div class="admit-scoreLine-box-table" style="margin-top: 40rpx;">
								<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
									<div class="admit-scoreLine-box-table-th-div table-lt" style="flex: 1;">
										学校
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										专业
									</div>
								</div>
								<div style="border: 1px solid #f0f0f0;">
									<div class="admit-scoreLine-box-table-list"
										v-for="(item,index) in info.zuoyueList" :key="index" v-if="index<dexnNumB">
										<div class="admit-scoreLine-box-table-list-div">
											{{item.schoolName?item.schoolName:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.majorName?item.majorName:'-'}}
										</div>
										
									</div>
								</div>
							</div>
						</div>
					</div>
					
					
					<div v-if="info.guoOneList" class="ub10">	
						<div class="jianjie-t">
							<div>国一流</div>
							
							<div v-if="info.guoOneList.length>5" @click="allC()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span :class="dexnNumC==5?'el-icon-arrow-down':'el-icon-arrow-up'"></span></div>
						</div>	
						<div >
							<div class="admit-scoreLine-box-table" style="margin-top: 40rpx;">
								<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
									<div class="admit-scoreLine-box-table-th-div table-lt" style="flex: 1;">
										学校
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										专业
									</div>
								</div>
								<div style="border: 1px solid #f0f0f0;">
									<div class="admit-scoreLine-box-table-list"
										v-for="(item,index) in info.guoOneList" :key="index" v-if="index<dexnNumC">
										<div class="admit-scoreLine-box-table-list-div">
											{{item.schoolName?item.schoolName:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.majorName?item.majorName:'-'}}
										</div>
										
									</div>
								</div>	
								
							</div>
						</div>
					</div>
					
					<div v-if="info.guoList" class="ub10">
						<div class="jianjie-t">
							<div>国家特色专业</div>
							<div v-if="info.guoList.length>5" @click="allD()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span :class="dexnNumD==5?'el-icon-arrow-down':'el-icon-arrow-up'"></span></div>
							</div>
						<div >
							<div class="admit-scoreLine-box-table" style="margin-top: 40rpx;">
								<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
									<div class="admit-scoreLine-box-table-th-div table-lt" style="flex: 1;">
										学校
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										专业
									</div>
								</div>
								<div style="border: 1px solid #f0f0f0;">
									<div class="admit-scoreLine-box-table-list"
										v-for="(item,index) in info.guoList" :key="index" v-if="index<dexnNumD">
										<div class="admit-scoreLine-box-table-list-div">
											{{item.schoolName?item.schoolName:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.majorName?item.majorName:'-'}}
										</div>
										
									</div>
								</div>
								
							</div>
						</div>
					</div>
					
					<div v-if="info.shengList" class="ub10">
						<div class="jianjie-t">
							<div>省级特色专业</div>
							
							<div v-if="info.shengList.length>5" @click="allE()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span :class="dexnNumE==5?'el-icon-arrow-down':'el-icon-arrow-up'"></span></div>
							</div>
						<div >
							<div class="admit-scoreLine-box-table" style="margin-top: 40rpx;">
								<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
									<div class="admit-scoreLine-box-table-th-div table-lt" style="flex: 1;">
										学校
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										专业
									</div>
								</div>
								<div class="admit-scoreLine-box-table-list"
									v-for="(item,index) in info.shengList" :key="index" v-if="index<dexnNumE">
									<div class="admit-scoreLine-box-table-list-div">
										{{item.schoolName?item.schoolName:'-'}}
									</div>
									<div class="admit-scoreLine-box-table-list-div">
										{{item.majorName?item.majorName:'-'}}
									</div>
									
								</div>
							</div>
						</div>
					</div>
					
					
					
					<div v-if="info.shuoshiList" class="ub10">
						<div class="jianjie-t">
							<div>硕士点专业</div>
							<div v-if="info.shuoshiList.length>5" @click="allAA()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span :class="dexnNumAA==5?'el-icon-arrow-down':'el-icon-arrow-up'"></span></div>
							</div>
						<div >
							<div class="admit-scoreLine-box-table" style="margin-top: 40rpx;">
								<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
									<div class="admit-scoreLine-box-table-th-div table-lt" style="flex: 1;">
										学校
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										专业
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										院系
									</div>
								</div>
								<div class="admit-scoreLine-box-table-list"
									v-for="(item,index) in info.shuoshiList" :key="index" v-if="index<dexnNumAA">
									<div class="admit-scoreLine-box-table-list-div">
										{{item.schoolName?item.schoolName:'-'}}
									</div>
									<div class="admit-scoreLine-box-table-list-div">
										{{item.majorName?item.majorName:'-'}}
									</div>
									<div class="admit-scoreLine-box-table-list-div">
										{{item.remark?item.remark:'-'}}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="info.boshiList" class="ub10">
						<div class="jianjie-t">
							<div>博士点专业</div>
							<div v-if="info.boshiList.length>5" @click="allBB()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span :class="dexnNumBB==5?'el-icon-arrow-down':'el-icon-arrow-up'"></span></div>
							</div>
						<div >
							<div class="admit-scoreLine-box-table" style="margin-top: 40rpx;">
								<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
									<div class="admit-scoreLine-box-table-th-div table-lt" style="flex: 1;">
										学校
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										专业
									</div>
								</div>
								<div class="admit-scoreLine-box-table-list"
									v-for="(item,index) in info.boshiList" :key="index" v-if="index<dexnNumBB">
									<div class="admit-scoreLine-box-table-list-div">
										{{item.schoolName?item.schoolName:'-'}}
									</div>
									<div class="admit-scoreLine-box-table-list-div">
										{{item.majorName?item.majorName:'-'}}
									</div>
									
								</div>
							</div>
						</div>
					</div>
					
					
				</div>
			
			
				<div class="jianjie">
					<div class="jianjie-t" v-if="info.dormitoryStandard||info.campusWifi||info.bathroom||info.balcony">食宿条件</div>
					<div v-if="info.dormitoryStandard||info.campusWifi||info.bathroom||info.balcony">
						<div class="sstj" >
							<div class="sstjli" v-if="info.dormitoryStandard">
								<img src="../../assets/img/ss1.png" alt="">
								<div class="sstjlitext">{{info.dormitoryStandard?info.dormitoryStandard:'-'}}</div>
							</div>
							<div class="sstjli" v-if="info.campusWifi">
								<img src="../../assets/img/ss2.png" alt="">
								<div class="sstjlitext">{{info.campusWifi?info.campusWifi:'-'}}</div>
							</div>
							<div class="sstjli" v-if="info.bathroom">
								<img src="../../assets/img/ss3.png" alt="">
								<div class="sstjlitext">{{info.bathroom?info.bathroom:'-'}}</div>
							</div>
							<div class="sstjli" v-if="info.balcony">
								<img src="../../assets/img/ss4.png" alt="">
								<div class="sstjlitext">{{info.balcony?info.balcony:'-'}}</div>
							</div>
						</div>
					</div>
					<div class="jianjie-t" v-if="info.dormitory">宿舍</div>
					<div class="jianjie-m" v-html="info.dormitory"></div>
					<div class="jianjie-t" v-if="info.canteen">食堂</div>
					<div class="jianjie-m" v-html="info.canteen"></div>
				</div>
			</div>
			
			<div class="jiben jiben-a" v-if="false">
				<div class="jianjie">
					<div class="jianjie-t">
						<div>历年录取分数线</div>
					<!-- 	<div v-if="scores_line_list&&scores_line_list.length>dexnNumF" @click="allF()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span class="el-icon-arrow-right"></span></div> -->
						
						<!-- <div v-if="scores_line_list.length>5" @click="allF()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span :class="dexnNumF==5?'el-icon-arrow-down':'el-icon-arrow-up'"></span></div> -->
						
						
						</div>
					<div >
					<!-- <nVip @child-event="handleChildEvent" v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip> -->
					<!-- <div v-if="user.userVip==1"> -->
					<el-form :model="queryParams" ref="queryForm" size="small" :inline="true"  label-width="68px" @submit.native.prevent style="margin-bottom: 10px;">
					  <el-form-item label="" prop="">
					  	<el-select v-model="addData.year" clearable placeholder="请选择" @change="changeA">
					  		<el-option
					  			v-for="item in yearData"
					  			:key="item.year"
					  			:label="item.year"
					  			:value="item.year">
					  		</el-option>
					  	</el-select>
					  </el-form-item>
					  <el-form-item label="" prop="">
					  	<el-select v-model="addData.batchId" clearable placeholder="请选择" @change="changeA">
					  		<el-option
					  			v-for="item in batchIdData"
					  			:key="item.id"
					  			:label="item.name"
					  			:value="item.id">
					  		</el-option>
					  	</el-select>
					  </el-form-item>
					  <el-form-item label="" prop="">
					  	<el-select v-model="addData.majorName" clearable placeholder="请选择" @change="changeA">
					  		<el-option
					  			v-for="item in majorName"
					  			:key="item.lable"
					  			:label="item.lable"
					  			:value="item.lable">
					  		</el-option>
					  	</el-select>
					  </el-form-item>
					</el-form>
						<div class="admit-scoreLine-box-table" >
							<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
								<div class="admit-scoreLine-box-table-th-div table-lt" style="flex: 2;">
									专业名称
								</div>
								<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
									代码
								</div>
								<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
									最低分
								</div>
								<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
									位次
								</div>
								<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
									选科
								</div>
								<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
									录取
								</div>
							</div>
							<div style="border:1px solid #f0f0f0;">
								<div class="admit-scoreLine-box-table-list"
									v-for="(item,index) in scores_line_list" :key="index" >
									<div class="admit-scoreLine-box-table-list-div"  style="flex: 2;">
										{{item.majorName?item.majorName:'-'}}
									</div>
									<div class="admit-scoreLine-box-table-list-div">
										{{item.schoolCode?item.schoolCode:'-'}}
									</div>
									<div class="admit-scoreLine-box-table-list-div">
										{{item.branchs?item.branchs:'-'}}
									</div>
									<div class="admit-scoreLine-box-table-list-div">
										{{item.rank?item.rank:'-'}}
									</div>
									<div class="admit-scoreLine-box-table-list-div">
										{{item.kemu?item.kemu:'-'}}
									</div>
									<div class="admit-scoreLine-box-table-list-div">
										{{item.plan?item.plan:'-'}}
									</div>
								</div>
							</div>
						</div>	
					</div>
					
					<!-- <div v-if="!token&&!user.score"><el-empty description="请先登录完善信息"></el-empty></div>
					
					</div> -->
				</div>
				
				
				
				
				
				
			</div>
			<div class="jiben jiben-a" v-if="false">
				
				<div class="jianjie">
					<div class="jianjie-t">
						<div>招生计划</div>
						
					<!-- 	
						<div v-if="scores_line_listZhao.length>5" @click="allG()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span :class="dexnNumG==5?'el-icon-arrow-down':'el-icon-arrow-up'"></span></div> -->
						</div>
					<div >
					
					<nVip @child-event="handleChildEvent" v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip>
					<div v-if="user.userVip==1">
						<el-form :model="queryParams" ref="queryForm" size="small" :inline="true"  label-width="68px" @submit.native.prevent style="margin-bottom: 10px;">
						  <el-form-item label="" prop="">
						  	<el-select v-model="addDataB.year" clearable placeholder="请选择" @change="changeB">
						  		<el-option
						  			v-for="item in yearData"
						  			:key="item.year"
						  			:label="item.year"
						  			:value="item.year">
						  		</el-option>
						  	</el-select>
						  </el-form-item>
						  <el-form-item label="" prop="">
						  	<el-select v-model="addDataB.batchId" clearable placeholder="请选择" @change="changeB">
						  		<el-option
						  			v-for="item in batchIdData"
						  			:key="item.id"
						  			:label="item.name"
						  			:value="item.id">
						  		</el-option>
						  	</el-select>
						  </el-form-item>
						  <el-form-item label="" prop="">
						  	<el-select v-model="addDataB.majorName" clearable placeholder="请选择" @change="changeB">
						  		<el-option
						  			v-for="item in majorName"
						  			:key="item.lable"
						  			:label="item.lable"
						  			:value="item.lable">
						  		</el-option>
						  	</el-select>
						  </el-form-item>
						</el-form>
							<!-- <div class="admit-scoreLine-box-table" >
								<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
									<div class="admit-scoreLine-box-table-th-div table-lt" style="flex:2;">
										专业名称
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										选科
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										学制
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										招生人数
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										学费
									</div>
								</div>
								<div style="border: 1px solid #f0f0f0;">
									<div class="admit-scoreLine-box-table-list"
										v-for="(item,index) in scores_line_listZhao" :key="index" >
										<div class="admit-scoreLine-box-table-list-div" style="flex:2;">
											{{item.majorName?item.majorName:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.kemu?item.kemu:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.yearEdu?item.yearEdu:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.plan?item.plan:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.money?item.money+'/年':'-'}}
										</div>
									</div>
								</div>
							</div> -->
							<div class="admit-scoreLine-box-table" >
								<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
									<div class="admit-scoreLine-box-table-th-div table-lt" style="flex:1;">
										专业代码
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 2;">
										专业名称
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										代码
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										选科
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										学制
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										招生人数
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										学费
									</div>
								</div>
								<div style="border: 1px solid #f0f0f0;">
									<div class="admit-scoreLine-box-table-list"
										v-for="(item,index) in scores_line_listZhao" :key="index" >
										<div class="admit-scoreLine-box-table-list-div" >
											{{item.majorCode?item.majorCode:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div" style="flex:2;">
											{{item.majorName?item.majorName:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.schoolCode?item.schoolCode:'-'}}
										</div>
										
										<div class="admit-scoreLine-box-table-list-div">
											{{item.kemu?item.kemu:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.yearEdu?item.yearEdu:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.plan?item.plan:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.money?item.money+'/年':'-'}}
										</div>
									</div>
								</div>
							</div>
					</div>
					
					<div v-if="!token&&!user.score"><el-empty description="请先登录完善信息"></el-empty></div>
					
					</div>
				</div>
			</div>
			
			<div class="jiben jiben-a" v-if="navDataIndex==2">
				
				 <div class="employment-whereabouts card-box jianjie" v-if="info.jobrate">
				 	<div class="employment-whereabouts-title">
				 		<span>毕业选择</span>
				 	</div>
				 	
				 		<div class="employment-whereabouts-list" >
				 			<div class="employment-whereabouts-list-item"
				 				v-for="(item,index) in info.jobrate" :key="index">
				 				<span v-if="index=='abroad'">出国率</span>
				 				<span v-if="index=='job'">就业率</span>
				 				<span v-if="index=='postgraduate'">国内升学率</span>
				 				<div class="progress">
				 					<div class="progress-bg">
				 						<div class="progress-bg-active" :style="{width:item+'%'}">
				 						</div>
				 					</div>
				 					<span>{{item}}%</span>
				 				</div>
				 			</div>
				 		</div>
				 	
				 </div>
				<div class="employment-whereabouts card-box jianjie" v-if="info.province">
					<div class="employment-whereabouts-title">
						<span>毕业生签约地区流向</span>
					</div>
					
						<div class="employment-whereabouts-list" >
							<div class="employment-whereabouts-list-item"
								v-for="(item,index) in info.province" :key="index">
								<span>{{item.province}}</span>
								<div class="progress">
									<div class="progress-bg">
										<div class="progress-bg-active" :style="{width:item.rate+'%'}">
										</div>
									</div>
									<span>{{item.rate}}%</span>
								</div>
							</div>
						</div>
				
				</div>
				<div class="employment-whereabouts card-box jianjie" v-if="info.attr">
					<div class="employment-whereabouts-title">
						<span>毕业生就业单位性质</span>
					</div>
				
						<div class="employment-whereabouts-list">
							<div class="employment-whereabouts-list-item" v-for="(item,index) in info.attr" :key="index">
								<span>{{index}}</span>
								<div class="progress">
									<div class="progress-bg">
										<div class="progress-bg-active" :style="{width:item+'%'}">
										</div>
									</div>
									<span>{{item}}%</span>
								</div>
							</div>
						</div>
					
				</div>
				
				
				<div class="employment-whereabouts card-box jianjie" style="position: relative;" v-if="info.company">
					<div class="employment-whereabouts-title">
						<span>毕业生就业单位</span>
					</div>
					<div class="employment-whereabouts-list" >
						<div class="employment-company-list" >
							<div class="employment-company-list-top">
								<div>签约单位</div>
								<div>人数</div>
							</div>
							<div class="employment-company-list-item"
								v-for="(item,index) in info.company" :key="index">
								<div>{{item.name}}</div>
								<div style="color: #F24041;">{{item.num}}</div>
							</div>
						</div>
					</div>
				</div>
				
				
				
				
			</div>
		
			<div class="jiben jiben-a" v-if="navDataIndex==1">
				
				<div class="jianjie">
					<div class="jianjie-t">
						<div>招生计划</div>
						
					<!-- 	
						<div v-if="scores_line_listZhao.length>5" @click="allG()" style="text-align: center;font-size: 12px;font-weight:normal;cursor: pointer">查看全部<span :class="dexnNumG==5?'el-icon-arrow-down':'el-icon-arrow-up'"></span></div> -->
						</div>
					<div >
					
					<!-- <nVip @child-event="handleChildEvent" v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip> -->
					<div >
						<el-form :model="queryParams" ref="queryForm" size="small" :inline="true"  label-width="68px" @submit.native.prevent style="margin-bottom: 10px;">
						  <el-form-item label="" prop="">
						  	<el-select v-model="addDataB.year" clearable placeholder="请选择" @change="changeB">
						  		<el-option
						  			v-for="item in yearData"
						  			:key="item.year"
						  			:label="item.year"
						  			:value="item.year">
						  		</el-option>
						  	</el-select>
						  </el-form-item>
						  <el-form-item label="" prop="">
						  	<el-select v-model="addDataB.batchId" clearable placeholder="请选择" @change="changeB">
						  		<el-option
						  			v-for="item in batchIdData"
						  			:key="item.id"
						  			:label="item.name"
						  			:value="item.id">
						  		</el-option>
						  	</el-select>
						  </el-form-item>
						  <el-form-item label="" prop="">
						  	<el-select v-model="addDataB.majorName" clearable placeholder="请选择" @change="changeB">
						  		<el-option
						  			v-for="item in majorName"
						  			:key="item.lable"
						  			:label="item.lable"
						  			:value="item.lable">
						  		</el-option>
						  	</el-select>
						  </el-form-item>
						</el-form>
							<div class="admit-scoreLine-box-table" >
								<div class="admit-scoreLine-box-table-th" style="height: 100rpx;display: flex;background: #F5FAFE;width: 100%;height: 50px;line-height: 50px;">
									<div class="admit-scoreLine-box-table-th-div table-lt" style="flex:1;">
										专业代码
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 2;">
										专业名称
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										代码
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										选科
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										学制
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										招生人数
									</div>
									<div class="admit-scoreLine-box-table-th-div "style="flex: 1;">
										学费
									</div>
								</div>
								<div style="border: 1px solid #f0f0f0;">
									<div class="admit-scoreLine-box-table-list"
										v-for="(item,index) in scores_line_listZhao" :key="index" >
										<div class="admit-scoreLine-box-table-list-div" >
											{{item.majorCode?item.majorCode:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div" style="flex:2;">
											{{item.majorName?item.majorName:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.schoolCode?item.schoolCode:'-'}}
										</div>
										
										<div class="admit-scoreLine-box-table-list-div">
											{{item.kemu?item.kemu:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.yearEdu?item.yearEdu:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.plan?item.plan:'-'}}
										</div>
										<div class="admit-scoreLine-box-table-list-div">
											{{item.money?item.money+'/年':'-'}}
										</div>
									</div>
								</div>
							</div>
					</div>
					
					<!-- <div v-if="!token&&!user.score"><el-empty description="请先登录完善信息"></el-empty></div> -->
					
					</div>
				</div>
			</div>
		</div>
			<!-- 学校列表 -->
	</div>
	<div ref="loadMoreTrigger" style="height: 100px;"></div>
    
  </div>
</template>

<script>
	import  {UPLODE_URL} from '@/utils/request'
	import { EventBus } from '@/utils/event-bus.js';
	import nVip from '@/components/n-vip.vue';
export default {
	components: {
		nVip
	},
  data() {
    return {
		UPLODE_URL,
		token: localStorage.getItem('token')||'',
		user:JSON.parse(localStorage.getItem('user'))||'',
		user:{cityId:37},
		
		
		id:'',
		// navData:['学校概况','录取预测','招生计划','就业方向',],
		navData:['学校概况','招生计划','就业方向'],
		navDataIndex:0,
		info:{},
		chineseArray:[],//学科评估汉字
		gradeArray:[],//学科评估 等级
		dexnNum:5,
		dexnNumB:5, 
		dexnNumC:5,
		dexnNumD:5,
		dexnNumE:5,
		dexnNumF:5,
		dexnNumG:5,
		
		dexnNumAA:5,
		dexnNumBB:5,
		
		
		
		
		// 查询参数
		queryParams: {
		  pageNum: 1,
		  pageSize: 10,
		  name:'',mobile:'',typeGui:''
		},
		addData:{
			year:'',
			cityId:'',
			batchId:'',
			yearZhao:'',
			batchIdZhao:'',
			majorName:'',
			majorNameZhao:''
		},
		addDataB:{
			year:'',
			cityId:'',
			batchId:'',
			yearZhao:'',
			batchIdZhao:'',
			majorName:'',
			majorNameZhao:''
		},
		yearData:[],
		//专业分数线
		scores_line_list: [],
		scores_line_listZhao: [],
		//招生计划
		plan_list: [],
		batchIdData:[],
		schoolName:'',
		news_page:1,
		college_id:'',
		majorName:[{lable:'地方专项'},{lable:'中外合作'},{lable:'济南走读'},{lable:'面向青岛招生'},{lable:'定向西藏'}],
		tokenNew:'eyJhbGciOiJIUzI1NiJ9.eyJpZCI6MjgwNywiZXhwIjoxODQ4MzkyMzc4fQ.2cNzE1AH3YpO89eWNfzn5G9gIH4ghpLFIMn7gBr86Hw'
    };
  },

  created() {
    this.token=localStorage.getItem('token')||''
    // this.user=JSON.parse(localStorage.getItem('user'))||''
	this.id = localStorage.getItem('xiaoid')
	this.schoolName = localStorage.getItem('schoolName')
  },
  mounted() {
	let that = this
  	that.getList();
	that.morenYear()
	 // 登录完 确定完 去请求录取接口
	EventBus.$on("callLoginDialog", () => {
		that.token=localStorage.getItem('token')||''
		that.user=JSON.parse(localStorage.getItem('user'))||''
		// that.morenYear()
	});
	window.addEventListener('storage', this.handleStorageEvent);
  },
  beforeDestroy() {
  	 window.removeEventListener('storage', this.handleStorageEvent);
    },
  methods: {
	  
	  handleStorageEvent(event) {
	        if (event.key == 'token') {
	          // 更新登录状态
	  			this.token=localStorage.getItem('token')||''
	  			// this.user=JSON.parse(localStorage.getItem('user'))||''
	  			this.$router.push({path:'/'})
	  			window.location.reload()
	          // this.checkLoginStatus();
	        }
	      },
	  goGw(e){
		  console.log('e',e)
		  window.open(e,'_blank');
	  },
	  // 接收子组件参数
	  handleChildEvent(i){
		  console.log('i',i)
		  // EventBus.$emit('noopsycheOpen');
		  // EventBus.$emit('open');
		  // EventBus.$emit('vipOpen');
		  if(i==1){
			  EventBus.$emit('noopsycheOpen');
		  }else if(i==2){
			EventBus.$emit('open');
		  }else{
			  EventBus.$emit('vipOpen');
		  }
	  },
	  // 筛选 change事件
	  changeA(){
		  this.getLu()
	  },
	  // 筛选 change事件
	  changeB(){
	  		  this.getZhao()
	  },
	  morenYear(){
		  this.api.homeDJi().then(res => {this.getYear(res.data)})
	  },
	  getYear(year){
		  console.log('this21212.user',this.user)
		  let quer = {
			  cityId:this.user.cityId,
			  // cityId:37,
			  type:1,
		  }
		  this.api.homeBranchTypeJiApi(quer).then(res => {
			  this.yearData = res.data
			  this.addData.year = res.data[0].year
			  this.addDataB.year = res.data[0].year
			  this.getLuPici(this.user.cityId,year)//获取历年录取数据
		  })
	  },
	  getLuPici(cityId,year){
		  let quer = {
		  		cityId:cityId,
		  }
		  this.api.appBatchLIstApi(quer).then(res => {
			  this.batchIdData=res.data
			  
		  	  this.addData.batchId =this.user.batchId||''
		  	  this.addDataB.batchId =this.user.batchId||res.data[0].id
				
			  // this.getLu(res.data[0].id,cityId,year)//获取历年录取数据
			  this.getZhao(res.data[0].id,cityId,year)
		  })
	  },
	  
	  // 获取录取数据表格
	  getLu(){
		  console.log('andjkahdjkbajksbjk')
		  let quer = {
				 batchId:this.addData.batchId,
				 cityId:this.user.cityId,
				 year:this.addData.year,
				 pageNum:this.news_page,
				 pageSize:100000000,
				 schoolId: this.id,
				 schoolName:this.schoolName||'',
				 majorName:this.addData.majorName
		  }
		  this.api.appLuApi(quer).then(res => {
			  console.log('res',res)
			  if(res.code==200){
				  if(res.data&&res.data.rows){
					  this.scores_line_list = res.data.rows
				  }else{
					  this.scores_line_list =[]
				  }
			  }
		  })
	  },
	  // 获取招生计划 数据表格
	  getZhao(){
		  console.log('andjkahdjkbajksbjk')
		  let quer = {
				 batchId:this.addDataB.batchId,
				 cityId:this.user.cityId,
				 year:this.addDataB.year,
				 pageNum:this.news_page,
				 pageSize:100000000,
				 schoolId: this.id,
				 schoolName:this.schoolName||'',
				 majorName:this.addDataB.majorName,
				 token:'eyJhbGciOiJIUzI1NiJ9.eyJpZCI6MjgwNywiZXhwIjoxODQ4MzkyMzc4fQ.2cNzE1AH3YpO89eWNfzn5G9gIH4ghpLFIMn7gBr86Hw'
		  }
		  this.api.appYearApi(quer).then(res => {
			  console.log('res',res)
			  if(res.code==200){
				  if(res.data&&res.data.rows){
					  this.scores_line_listZhao = res.data.rows
				  }else{
					  this.scores_line_listZhao =[]
				  }
			  }
		  })
	  },
	  
	  allA(){
		  if(this.dexnNum==5){
			  this.dexnNum=10000
		  }else if(this.dexnNum==10000){
			  this.dexnNum=5
		  }
	  },
	  allB(){
		  if(this.dexnNumB==5){
		  			  this.dexnNumB=10000
		  }else if(this.dexnNumB==10000){
		  			  this.dexnNumB=5
		  }
	  },
	  allC(){
		  if(this.dexnNumC==5){
		  			  this.dexnNumC=10000
		  }else if(this.dexnNumC==10000){
		  			  this.dexnNumC=5
		  }
	  },
	  allD(){
		  if(this.dexnNumD==5){
		  			  this.dexnNumD=10000
		  }else if(this.dexnNumD==10000){
		  			  this.dexnNumD=5
		  }
	  },
	  allE(){
		  if(this.dexnNumE==5){
		  			  this.dexnNumE=10000
		  }else if(this.dexnNumE==10000){
		  			  this.dexnNumE=5
		  }
	  },
	  allF(){
		  if(this.dexnNumF==5){
		  			  this.dexnNumF=10000
		  }else if(this.dexnNumF==10000){
		  			  this.dexnNumF=5
		  }
	  },
	  allG(){
	  		  if(this.dexnNumG==5){
	  		  			  this.dexnNumG=10000
	  		  }else if(this.dexnNumG==10000){
	  		  			  this.dexnNumG=5
	  		  }
	  },
	  
	  allAA(){
		  if(this.dexnNumAA==5){
		  			  this.dexnNumAA=10000
		  }else if(this.dexnNumAA==10000){
		  			  this.dexnNumAA=5
		  }
	  },
	  allBB(){
	  		  if(this.dexnNumBB==5){
	  		  			  this.dexnNumBB=10000
	  		  }else if(this.dexnNumBB==10000){
	  		  			  this.dexnNumBB=5
	  		  }
	  },
	  
	 navClick(i){
		 // this.token=localStorage.getItem('token')||''
		 // this.user=JSON.parse(localStorage.getItem('user'))||''
		 //   this.user.cardOne = 210
		 //  let ss = JSON.stringify(this.user)
		 // localStorage.setItem('user',ss)
		 
		
		 this.navDataIndex=i
		 // if(i!=0){
			//  if(!this.token) {
			//  	EventBus.$emit('noopsycheOpen');
			//  }else if(!this.user.score){
			//  	EventBus.$emit('showModal');
			//  	return
			//  }
		 // }
		 this.$forceUpdate()
	 },
	  // 获取筛选省份
	   city(){
		   this.api.homeCityListApi().then(res => {this.filtrate.F = res.data})
	   },
	  
	   schGet(){
		   this.queryParams.pageNum = 1;
		   this.getList()
	   },
	   // handleScroll(e) {
		  //  console.log('11111',e)
	   //       const bottomOffset = 50; // 距离底部多少像素时触发加载
	   //       const scrollContainer = this.$refs.scrollContainer;
	   //       if (scrollContainer.scrollHeight - (scrollContainer.scrollTop + scrollContainer.clientHeight) < bottomOffset) {
	   //         this.getList();
	   //       }
	   //     },
	   // 数据列表请求
	   getList(type){
		   // if(!this.token){
			  //  return
		   // }
		   let qu = {
			   id:this.id
		   }
		    this.api.homeSchoolInfoApi(qu).then(res => {
				if(res.code==200){
					if(res.data.schoolImage){
						res.data.schoolImage = res.data.schoolImage.split(",")
					}
					if(res.data.fourCourse&&res.data.fourCourse!='--'){
						const str = res.data.fourCourse;
						 
						// 使用顿号分割字符串成数组
						const parts = str.split('、');
						 
						// 初始化两个空数组来存储结果
						const chineseArray = [];
						const gradeArray = [];
						 
						// 遍历每个分割后的部分
						parts.forEach(part => {
						  // 检查该部分是否包含等级（以大写字母开头，可能跟着加号或减号）
						  const gradeMatch = part.match(/([A-Z][+-]?)/);
						  
						  if (gradeMatch) {
						    // 提取等级
						    const grade = gradeMatch[0];
						    
						    // 找到等级在字符串中的位置
						    const gradeIndex = part.indexOf(grade);
						    
						    // 提取汉字部分（等级前面的所有字符）
						    const chinese = part.slice(0, gradeIndex);
						    
						    // 将提取到的汉字和等级添加到数组中
						    chineseArray.push(chinese.trim()); // 使用trim去除可能的空格
						    gradeArray.push(grade);
						  } else {
						    // 如果该部分不包含等级（如“理论经济学”），则只添加汉字部分
						    chineseArray.push(part.trim());
						    gradeArray.push(null); // 或者使用其他方式表示没有等级，比如空字符串''
						  }
						});
						 
						// 输出结果
						this.chineseArray = chineseArray;
						this.gradeArray = gradeArray;
					}
					// 毕业生签约地区流向
					res.data.province = res.data.province ? JSON.parse(res.data.province) : null;
					// 毕业选择
					res.data.jobrate = res.data.jobrate ? JSON.parse(res.data.jobrate) : null;
					
					
					// 毕业生就业单位性质
					res.data.attr = res.data.attr ? JSON.parse(res.data.attr) : null;
					
					
					// 毕业生就业单位
					res.data.company = res.data.company ? JSON.parse(res.data.company) : null;
					if (Array.isArray(res.data.company)) {
					  console.log('company 是数组');
					  if(res.data.company.length){
						let company = [];
						for (let key in res.data.company) {
							company.push({
								"name": res.data.company[key].danName,
								"num": res.data.company[key].peopleNum
							})
						}
						res.data.company = company  
						console.log('company 是数组的最后格式',res.data.company);
					  }
						
					} else {
					  console.log('company 不是数组',res.data.company);
					  if (res.data.company) {
					  	let company = [];
					  	for (let key in res.data.company) {
					  		company.push({
					  			"name": key,
					  			"num": res.data.company[key]
					  		})
					  	}
					  	res.data.company = company
					  	console.log('company 不是数组最后格式',res.data.company);
					  }
					}
					
					this.info = res.data
					console.log('schoolImage',res.data.company)
				}else{
					 this.$message.error(res.msg);
				}
			})
	   }
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.box{
	/deep/.el-form-item__content{
		flex: 1;
	}
	.el-form-item--small.el-form-item {
		margin-bottom: 5px;
	}
	// height: 100vh;
	// min-height: 30vh;
	.boxA{
		background: #fff;
		border-radius: 10px;
		padding: 10px 20px 20px 20px;
		margin-top: 10px;
		.box-tit{
			width: 100%;
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #F44F4D;
			margin-bottom: 15px;
			display: flex;
			span{
				width: 140px;
				height: 40px;
				line-height: 40px;
				cursor: pointer;
				display: block;
				text-align: center;
				font-size: 15px;
			}
			span.onsele{
				background-color: #F44F4D;
				color: #fff;
				border-radius: 10px 10px 0 0;
				font-size: 15px;
			}
		}
		
		.search-t{
			width: 30%;
			margin-bottom: 10px;
			.input-with-select{
				border-radius: 4px;
				/deep/.el-input__inner{
					border-color: #F56C6C!important;
				}
				/deep/.el-button--danger{
					border: none!important;
				}
				/deep/.el-button{
					border: 1px solid #f44f4d!important;
					background: #f44f4d;
					color: #fff;
					border-radius: 0  4px 4px 0px;
				}
			}
		}
		
		.topsec{
			
			.kuai{
				display: flex;
				flex-wrap: wrap;
				span{
					margin-right: 20px;
					cursor: pointer;
				}
				span.onsele{
					color: #F44F4D;
				}
			}
			.el-form-item {
				display: flex;
			}
		}
	
		.jiben{
			.introduction-rank-list{
				display: flex;
				.introduction-rank-list-box{
					font-size: 14px;
					background: linear-gradient(0deg,#f8f8f8,#f8f8f8);
					    width: 23%;
					    height: 30px;
					    text-align: center;
					    padding: 15px;
						margin-right: 15px;
						border-radius: 8px;
						.nnna{
							color: #F44F4D;
						}
				}
			}
		}
		
		.jianjie{
			margin-top: 20px;
			position: relative;
			.jianjie-t{
				font-size: 16px;
				color: #333;
				font-weight: bold;
				margin-bottom: 10px;
				display: -webkit-box;
				display: -webkit-flex;
				display: -ms-flexbox;
				display: flex;
				-webkit-box-pack: justify;
				-webkit-justify-content: space-between;
				-ms-flex-pack: justify;
				margin-top: 10px;
			}
			.jianjie-m{
				font-size: 14px;
				line-height: 26px;
			}
			.admit-scoreLine-box-table-th{
				margin-bottom: 10px;
			}
			.admit-scoreLine-box-table-list{
				width: 100%;
				display: flex;
				.admit-scoreLine-box-table-list-div{
					flex: 1;
					// margin-bottom: 6px;
					text-align: center;
					line-height: 40px;
					    border-bottom: 1px solid #f0f0f0;
				}
				
			}
			
			
			
			// <div class="sstj" >
			// 	<div class="sstjli" v-if="info.dormitoryStandard">
			// 		<img src="../../assets/img/ss1.png" alt="">
			// 		<div class="sstjlitext">{{info.dormitoryStandard?info.dormitoryStandard:'-'}}</div>
			// 	</div>
			// 	<div class="sstjli" v-if="info.campusWifi">
			// 		<img src="../../assets/img/ss2.png" alt="">
			// 		<div class="sstjlitext">{{info.campusWifi?info.campusWifi:'-'}}</div>
			// 	</div>
			// 	<div class="sstjli" v-if="info.bathroom">
			// 		<img src="../../assets/img/ss3.png" alt="">
			// 		<div class="sstjlitext">{{info.bathroom?info.bathroom:'-'}}</div>
			// 	</div>
			// 	<div class="sstjli" v-if="info.balcony">
			// 		<img src="../../assets/img/ss4.png" alt="">
			// 		<div class="sstjlitext">{{info.balcony?info.balcony:'-'}}</div>
			// 	</div>
			// </div>
			
			.sstj{
				display: flex;
				.sstjli{
					text-align: center;
					margin-right: 30px;
					img{
						width: 20px;
						height: 20px;
						background-color: #F5FAFE;
						border-radius: 5px;
						padding: 15px;
						margin-bottom: 4px;
					}
				}
			}
			
			
		}
	}
	
	
	.schmain{
		margin-top: 12px;
		.sch-ul{
			background: #fff;
			border-radius: 10px;
			// .sch-li:hover{
			// 	.schli-rt-a{
			// 		color: #F44F4D;
			// 	}
			// }
			.sch-li{
				
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				padding: 20px;
				.schli-l{
					width: 60px;
					height: 60px;
					margin-right: 20px;
					img{
						width: 60px;
						height: 60px;
						border-radius: 50%;
					}
				}
				.schli-r{
					flex: 1;
					.schli-rt{
						display: flex;
						align-items: center;
						margin-bottom: 10px;
						.schli-rt-a{
							font-size: 22px;
						}
						.schli-rt-b{
							margin-left: 10px;
							    height: 25px;
								line-height: 25px;
							    border-radius: 26px;
							    border: 1px solid #d8d8d8;
							    padding: 0 10px;
							    font-size: 12px;
							    color: #666;
						}
					}
					.schli-rb{
						margin-top: 6px;
						span{
							    height: 22px;
							    padding: 0 8px;
							    border-radius: 4px;
							    background: #f5f6f7;
							    font-size: 14px;
							    color: #666;
							    margin-right: 8px;
						}
					}
				}
			}

		
			// 顶部轮播图
			.home_top_swiper {
				// width: 100%;
				padding:0 20px 20px 20px;
				position: relative;
				border-radius: 10px;
				display: flex;
				.home_top_swiper_left{
					width: 442px;
					height: 200px;
					margin-right: 20px;
				}
				.home_top_swiper_right{
					
					.introduction-rank-list{
						display: flex;
						.introduction-rank-list-box{
							min-width: 110px;
							    height: 54px;
							    background: #fff9f2;
							    border-radius: 8px;
							    padding-top: 9px;
							    border: 1px solid #fff0e6;
								text-align: center;
								margin-right: 10px;
								.nnna{
									font-size: 20px;
									color: #f60;
								}
						}
					}
					
					
				
					.rightul{
						margin-top: 10px;
						.rightli{
							line-height: 25px;
							font-size: 15px;
						}
					}
					
					
					
					
				}
				// background-color: #9b0e12;
				// width: 440px;
				// swiper左右按钮
				/deep/ .el-car {
					width: 100%;
					height: 100%;
				}
			
				img {
					width: 100%;
					height:100%;
					object-fit: cover;
					border-radius: 10px;
				}
			
				// /deep/.el-carousel__item{
				// height: 100%;
				// }
				/deep/.el-carousel__arrow {
					// background-color: #30384d;
					width:30px;
					height:30px;
					// border-radius: 0px;
				}
			
				// 左右按钮图标
				/deep/.el-icon-arrow-left {
					font-size: 20px
				}
			
				/deep/.el-icon-arrow-right {
					font-size: 20px
				}
			}
		
		}
	}

	// <div class="employment-whereabouts card-box">
	// 	<div class="employment-whereabouts-title">
	// 		<span>毕业生签约地区流向</span>
	// 	</div>
	// 	<!-- <nVip @child-event="handleChildEvent" v-if="userVip==0" version="旗舰版" name="就业数据"></nVip> -->
	// 	<!-- :class="userVip==0?'blur':''" -->
	// 	<div >
	// 		<div class="employment-whereabouts-list" >
	// 			<div class="employment-whereabouts-list-item"
	// 				v-for="(item,index) in info.province" :key="index">
	// 				<span>{{item.province}}</span>
	// 				<div class="progress">
	// 					<div class="progress-bg">
	// 						<div class="progress-bg-active" :style="{width:item.rate+'%'}">
	// 						</div>
	// 					</div>
	// 					<span>{{item.rate}}%</span>
	// 				</div>
	// 			</div>
	// 		</div>
	// 	</div>
	// </div>
	.employment-whereabouts{
		position: relative;
		.employment-whereabouts-title{
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			color: #333;
			font-size: 16px;
			font-weight: bold;
			margin-bottom: 10px;
			margin-top: 10px;
		}
		 .employment-whereabouts-list {
		    border: 1px solid #ececec;
		    border-radius: 6px;
		    padding: 17px 15px 0 15px;
		    margin-top: 20px;
			 .employment-whereabouts-list-item {
			    display: flex;
			    flex-direction: column;
			    margin-bottom: 15px;
				span{
					font-size: 16px;
				}
				.progress {
				    display: flex;
				    flex-direction: row;
				    justify-content: space-between;
				    align-items: center;
					.progress-bg {
					    width: 88%;
					    height: 5px;
					    background-color: #ececec;
					    border-radius: 10px;
						.progress-bg-active {
						    background-color: #F24041;
						    border-radius: 10px;
						    height: 5px;
						}
					}
				}
			}
			
			
			
		}
		// 毕业生就业单位
		.employment-whereabouts-list{
			width: 50%;
			.employment-company-list{
				
				.employment-company-list-top{
					display: flex;
					justify-content: center;
					text-align: center;
					margin-bottom: 20px;
					div{
						flex:1;
						font-size:15px;
						color: #000;
					}
				}
				.employment-company-list-item{
					display: flex;
					justify-content: center;
					line-height: 40px;
					border-bottom:1px solid #f0f0f0;
					div{
						flex:1;
						font-size:13px;
						text-align: center;
						color: #5A5A5A;
					}
				}
			}
		}
		
	}
	

}
/deep/.el-checkbox-button.is-checked .el-checkbox-button__inner{
			background-color: #F34240!important;
			    border-color: #F34240!important;
			    box-shadow: -1px 0 0 0 #F34240!important;
		}
		/deep/.el-input.is-active .el-input__inner{
			border-color: #F34240!important;
		} 
		/deep/.el-input__inner:focus{
			border-color: #F34240!important;
		}
		.el-select-dropdown__item.selected {
		  color: #F34240!important
		}
/deep/.el-carousel__indicator--horizontal{
	padding: 12px 2px;
}
.introduction-major-box-list-item{
	line-height: 40px;
	border-bottom: 1px solid #f0f0f0;
}
.admit-scoreLine-box-table-th-div{
	font-size: 14px;
	text-align: center;
}
.admit-scoreLine-box-table-list-div{
	font-size: 14px;
}
.ub10{
	margin-bottom:30px;
}
.goGws{
	cursor: pointer;
}
.goGws:hover{
	color: #F24041;
}
</style>